import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAccessibility } from "@/components/ui/AccessibilityProvider";

export function RouteAnnouncer() {
  const location = useLocation();
  const { announce } = useAccessibility();

  useEffect(() => {
    const pageTitle = document.title || location.pathname;
    announce(`Navigated to ${pageTitle}.`);
  }, [announce, location.pathname, location.search]);

  return null;
}
